// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__165tQ","title":"ClientInsurance_title__tyuOF","itemText":"ClientInsurance_itemText__sqtGV"};